import { render, staticRenderFns } from "./payOrderList.vue?vue&type=template&id=56897f84&scoped=true"
import script from "./payOrderList.vue?vue&type=script&lang=ts"
export * from "./payOrderList.vue?vue&type=script&lang=ts"
import style0 from "./payOrderList.vue?vue&type=style&index=0&id=56897f84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56897f84",
  null
  
)

export default component.exports